module.exports = __webpack_public_path__ + "img/sms-icon.28f2e242.svg";